import { useHoursManagementPermission } from '../../../userManagementPermission';

/**
 * Hook to check phone hours management permission for a location
 * Consolidates the repeated permission checking pattern
 */
export const usePhoneHoursPermission = (locationId?: string) => {
  const hoursManagementPermission = useHoursManagementPermission();
  const hasPermission = hoursManagementPermission(locationId ?? '');

  return { hasPermission, hoursManagementPermission };
};
